export interface AcAdMenuItem {
  id: string;
  label: string;
  href?: string;
  children?: AcAdMenuItem[];
}

interface AcAdReactConfig {
  assetBaseUrl?: string;
  homeUrl?: string;
  contactEndpoint?: string;
  menuItems?: AcAdMenuItem[];
  currentPageSlug?: string;
  events?: AcAdEvent[];
  searchQuery?: string;
  searchResults?: AcAdSearchResult[];
  searchPagination?: {
    currentPage: number;
    totalPages: number;
    totalResults: number;
  };
}

export interface AcAdSearchResult {
  id: number | string;
  title: string;
  url: string;
  excerpt?: string;
  typeLabel?: string;
  date?: string;
  image?: string;
}

export interface AcAdEvent {
  id: number | string;
  title: string;
  eyebrow?: string;
  description: string;
  notes?: string[];
  startDate: string;
  endDate?: string;
  time?: string;
  location?: string;
  price?: string;
  whatsapp?: string;
  registrationUrl?: string;
  image?: string;
  featured?: boolean;
}

declare global {
  interface Window {
    ACAD_REACT_CONFIG?: AcAdReactConfig;
    ACADHome?: {
      mount: (element: HTMLElement) => void;
      unmount: () => void;
    };
    ACADAboutUs?: {
      mount: (element: HTMLElement) => void;
      unmount: () => void;
    };
    ACADBeliefs?: {
      mount: (element: HTMLElement) => void;
      unmount: () => void;
    };
    ACADMinistries?: {
      mount: (element: HTMLElement) => void;
      unmount: () => void;
    };
    ACADMissions?: {
      mount: (element: HTMLElement) => void;
      unmount: () => void;
    };
    ACADMm33?: {
      mount: (element: HTMLElement) => void;
      unmount: () => void;
    };
    ACADContact?: {
      mount: (element: HTMLElement) => void;
      unmount: () => void;
    };
    ACADRedPastoralYouth?: {
      mount: (element: HTMLElement) => void;
      unmount: () => void;
    };
    ACADNextGen?: {
      mount: (element: HTMLElement) => void;
      unmount: () => void;
    };
    ACADKingExplorers?: {
      mount: (element: HTMLElement) => void;
      unmount: () => void;
    };
    ACADExecutiveProfile?: {
      mount: (element: HTMLElement) => void;
      unmount: () => void;
    };
    ACADDonate?: {
      mount: (element: HTMLElement) => void;
      unmount: () => void;
    };
    ACADResources?: {
      mount: (element: HTMLElement) => void;
      unmount: () => void;
    };
    ACADSetad?: {
      mount: (element: HTMLElement) => void;
      unmount: () => void;
    };
    ACADEvents?: {
      mount: (element: HTMLElement) => void;
      unmount: () => void;
    };
    ACADSearchResults?: {
      mount: (element: HTMLElement) => void;
      unmount: () => void;
    };
  }
}

export function assetUrl(filename: string): string {
  const base = window.ACAD_REACT_CONFIG?.assetBaseUrl || "/assets/images";
  return `${base.replace(/\/$/, "")}/${filename.replace(/^\//, "")}`;
}

export function homeUrl(pathname = ""): string {
  const base = window.ACAD_REACT_CONFIG?.homeUrl || "/";
  return `${base.replace(/\/$/, "")}/${pathname.replace(/^\//, "")}`;
}
